// Module
var code = "<div sb-content-zoom parent-container-id=\"{{svg.parentId}}\" class=\"sb-svg-container\" id=\"sb-svg\" view-box=\"svg.viewBox\"></div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/visualizations/components/sbSvg/svg.tmpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;